import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=7cc41be8&scoped=true"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=7cc41be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc41be8",
  null
  
)

export default component.exports